import type { CalendarEvent, CreateCalendarEventInput, UpdateCalendarEventInput } from '@container-system/shared';
import { apiRequest } from './client';

export const calendarApi = {
  listForMonth: (month: string) => apiRequest<CalendarEvent[]>(`/api/calendar?month=${month}`),
  create: (input: CreateCalendarEventInput) => apiRequest<CalendarEvent>('/api/calendar', { method: 'POST', body: JSON.stringify(input) }),
  update: (id: string, input: UpdateCalendarEventInput) =>
    apiRequest<CalendarEvent>(`/api/calendar/${id}`, { method: 'PATCH', body: JSON.stringify(input) }),
  remove: (id: string) => apiRequest<null>(`/api/calendar/${id}`, { method: 'DELETE' }),
  markRemindersSent: () => apiRequest<null>('/api/calendar/reminders/mark-sent', { method: 'POST' }),
};
